
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
// interfaces
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";

//const auth = namespace("auth");
// const globals = namespace("globals");

@Component({
  components: {
  }
})
export default class DocumentMediaExtractionDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop() file!: FileDetailsVm;

  busy = false;
  disableButton = false;
  // extractAll = false;
  extractImages = true;
  range = [0, 5000];
  imageSiizeMin = 0;
  imageSizeMax = 5000;
  extractAudio = this.isPowerPoint;
  extractVideo = this.isPowerPoint;
  createMarkdownSummary = this.isPowerPoint;

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.extractImages = true;
      this.range = [0, 5000];
      this.imageSiizeMin = 0;
      this.imageSizeMax = 5000;
      this.extractAudio = this.isPowerPoint;
      this.extractVideo = this.isPowerPoint;
      this.createMarkdownSummary = this.isPowerPoint;

      await this.updateView();

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async updateView() {
  }

  get isPowerPoint() {
    if (!this.file || !this.file.name) return false;
    return this.file.name.toLowerCase().endsWith(".pptx");
  }

  get isPdf() {
    if (!this.file || !this.file.name) return false;
    return this.file.name.toLowerCase().endsWith(".pdf");
  }

  get isWord() {
    if (!this.file || !this.file.name) return false;
    return this.file.name.toLowerCase().endsWith(".docx");
  }

  async onExtractMediaFromPresentation() {
    if (!this.file) return;

    this.busy = true;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["FilePath"] = this.file.filePath ?? "";
    params.dictionary!["ExtractImages"] = this.extractImages.toString();
    params.dictionary!["ImageSizeMin"] = this.range[0].toString();
    params.dictionary!["ImageSizeMax"] = this.range[1].toString();
    params.dictionary!["ExtractAudio"] = this.extractAudio.toString();
    params.dictionary!["ExtractVideo"] = this.extractVideo.toString();
    params.dictionary!["CreateMarkdownSummary"] = this.createMarkdownSummary.toString();
    // params.dictionary!["CreateAiSummary"] = "false";

    try {
      let success = await rest.url("contentManager/extractMediaFilesFromDocument").post(params);

      if (success) {
        // vuex.ux.SB_SUCCESS({
        //   message: "Medien wurden extrahiert und zum Medienpool hinzugefügt.",
        //   timeout: 2000
        // });

        // Update MediaPool
        this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list
        this.syncedShowDialog = false;
      } else {
        // vuex.ux.SB_FAILURE({
        //   message: "Fehler beim Extrahieren der Medien.",
        //   timeout: 0
        // });
      }
    } finally {
      this.busy = false;
    }
  }

  onCancel() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }
}
